// @ts-check
import BaseController from './BaseController';
import ReportDataSource from '../dataSources/ReportDataSource';

class ReportController extends BaseController {
    static get name() {
        return 'ReportController';
    }

    static getInstance(options) {
        return new ReportController(options);
    }

    onActivate() {
        this.bindGluBusEvents({
            REPORT_LIMITS_LOAD_REQUEST: this.onReportLimitsLoadRequest,
            REPORT_LIMITS_GET_REQUEST: this.onReportLimitsGetRequest,
            REPORT_LIMITS_INCREMENT_USAGE_FROM_INFO_PANEL_REQUEST:
                this.onReportLimitsIncrementUsageInfoPanelRequest,
        });

        this.reportDataSource = this.activateSource(ReportDataSource);
    }

    onReportLimitsLoadRequest = () => {
        this.reportDataSource.getReportLimits().then(
            reportLimits => {
                this.bus.emit('REPORT_LIMITS_LOAD_SUCCESS', { reportLimits });
            },
            _ => {
                this.bus.emit('REPORT_LIMITS_LOAD_ERROR');
            },
        );
    };

    onReportLimitsGetRequest() {
        this.bus.emit('REPORT_LIMITS_GET_SUCCESS', this.reportDataSource.reportLimits);
    }

    onReportLimitsIncrementUsageInfoPanelRequest = ({ limits }) => {
        this.reportDataSource.incrementReportUsageByInfoPanel(limits);
        this.bus.emit('REPORT_LIMITS_GET_SUCCESS', this.reportDataSource.reportLimits);
    };

    onDeactivate() {
        this.unbindGluBusEvents();
    }
}

export default ReportController;
